(function() {
  const storageKey = 'printmo:faq-lead:pending:v1';
  const maxAge = 30 * 60 * 1000;

  function init() {
    document.querySelectorAll('.faq-chat-container').forEach(function(container) {
      if (container.dataset.leadTrackingInitialized) return;
      container.dataset.leadTrackingInitialized = 'true';
      const forms = [
        ['faq-question-form', 'question'],
        ['faq-quote-form', 'quote']
      ];

      forms.forEach(function(entry) {
        const form = container.querySelector('#' + entry[0]);
        if (!form) return;
        form.addEventListener('submit', function() {
          if (!form.checkValidity()) return;
          // CAPTCHA may prevent the native submit while verification is pending.
          // Keep only non-customer metadata; a submit attempt is not a success.
          try {
            sessionStorage.setItem(storageKey, JSON.stringify({
              eventId: window.crypto && window.crypto.randomUUID
                ? window.crypto.randomUUID()
                : Date.now().toString(36) + Math.random().toString(36).slice(2),
              formId: entry[0],
              leadForm: entry[1],
              sectionId: container.dataset.sectionId,
              pagePath: window.location.pathname,
              createdAt: Date.now()
            }));
          } catch (_) {
            // Storage restrictions must never prevent a customer inquiry.
          }
        });
      });

      try {
        const pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (!pending) return;
        const age = Date.now() - pending.createdAt;
        if (!Number.isFinite(age) || age < 0 || age > maxAge) {
          sessionStorage.removeItem(storageKey);
          return;
        }
        if (!pending.eventId || pending.sectionId !== container.dataset.sectionId ||
            pending.pagePath !== window.location.pathname) return;
        const entry = forms.find(function(candidate) {
          return candidate[0] === pending.formId && candidate[1] === pending.leadForm;
        });
        if (!entry || (window.location.hash && window.location.hash !== '#' + pending.formId)) return;
        const form = container.querySelector('#' + pending.formId);
        if (!form || !form.querySelector('[data-faq-lead-success="' + pending.leadForm + '"]')) return;

        // Both Liquid forms can render success for one Shopify response. Consume
        // the matching attempt before emission so the other form/reload cannot count it.
        sessionStorage.removeItem(storageKey);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lead_submit_success',
          event_id: pending.eventId,
          section_id: container.dataset.sectionId,
          section_name: container.dataset.sectionName,
          position: container.dataset.position,
          page_path: window.location.pathname,
          page_title: document.title,
          lead_source: 'faq_chat',
          lead_form: pending.leadForm
        });
      } catch (_) {
        // Fail closed for analytics; contact delivery remains Shopify-owned.
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
